import styled from 'styled-components';
import { IconCheck } from 'components/Icons';
import { AlignValueType } from './Timestamp.types';

export const StyledTimestampContainer = styled.div<{ align: AlignValueType }>`
  padding-top: ${(props) => props.theme.spacing['sm']};
  text-align: ${({ align }) => align};
`;

export const StyledIconCheck = styled(IconCheck)`
  color: ${(props) => props.theme.icon.success};
  margin-left: ${(props) => props.theme.spacing['xs']};
  position: relative;
  top: ${(props) => props.theme.spacing['xs']};
`;
